/**
 * Utility for resolving media URLs from the backend.
 * Prepends the backend base URL if the path is relative.
 */
export const resolveMediaUrl = (url: string | undefined | null): string => {
  if (!url) return "";

  // If it's an absolute URL (starts with http or https), return as is
  if (
    url.startsWith("http://") ||
    url.startsWith("https://") ||
    url.startsWith("blob:") ||
    url.startsWith("data:")
  ) {
    return url;
  }

  // If it's a relative path starting with /uploads, prepend the backend URL
  if (url.startsWith("/uploads")) {
    const backendUrl = import.meta.env.VITE_BACKEND_URL;
    if (!backendUrl) return url;
    // Ensure there's no double slash
    const baseUrl = backendUrl.endsWith("/")
      ? backendUrl.slice(0, -1)
      : backendUrl;
    return `${baseUrl}${url}`;
  }

  // Fallback: return as is if we don't recognize the pattern but it might be valid
  return url;
};
